import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Non-O Retirement Visa — วีซ่าเกษียณสำหรับชาวต่างชาติในไทย","metaTitle":"Non-O Retirement Visa (Thailand) — ยื่นครบจบพร้อม TM.30/90-day | NYC","metaDesc":"บริการยื่น Non-O Retirement 1 ปี พร้อมต่ออายุ 90-day report, TM.30, และ Multiple Re-entry สำหรับชาวต่างชาติอายุ 5 — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี"},"en":{"h1":"Non-O Retirement Visa — Thailand for Retirees 50+","metaTitle":"Thailand Non-O Retirement Visa — Full-Service Renewals | NYC","metaDesc":"Thailand Non-O Retirement 1-year visa with 90-day reporting, TM.30 and Multiple Re-entry for expats 5 — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/thai-visa/retirement")({
  head: () => {
    const url = `${SEO_SITE}/thai-visa/retirement`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/thai-visa/retirement", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/thai-visa/retirement", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/thai-visa/retirement", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/thai-visa/retirement", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/thai-visa/retirement", "/en/thai-visa/retirement")],
    };
  },
  component: () => <SubServicePage slug="thai-visa/retirement" locale="th" />,
});
